export default __webpack_public_path__ + "static/bot208-6956ee1f3d785880e23749f5efcfef56.jpeg";